var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AbstractFilters',{attrs:{"filters":_vm.filters,"on-click":_vm.filter,"selected-filter":_vm.communityFilter}})
}
var staticRenderFns = []

export { render, staticRenderFns }